import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSProperties } from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { getGroupByArray } from "../utils/misc";
import { CategoricalCellDto, ColumnIds, DatagridColumn, PageState } from "../utils/types";
import { addFilterAndGroupByToPageState, addFilterToPageState } from "./DatagridFiltersFunctions";
import StateHelper from "../utils/StateHelper";
import { FiltersInitialStateHelper } from "../common/FiltersInitialState";
import { isDateGroupBy } from "../common/FiltersEventsHelper";
import { UserInfo } from "../utils/types";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PagesHelper } from "../common/PagesHelper";

interface GridPopupMenuProps {
	categoricalCellDto:CategoricalCellDto;
	filteredColumn: DatagridColumn;
	cellValue: number|string;
	formattedValue: number|string;
	hideMenu: () => void;
	tdkey: string;
	currentUser: UserInfo;
}

const dateRangeColumnIds:ColumnIds[] = [ColumnIds.date, ColumnIds.week, ColumnIds.month];

export default function GridPopupMenu(props: GridPopupMenuProps) {
	const categoricalCellDto = props.categoricalCellDto;
	const column = props.filteredColumn;
	const cellValue = props.cellValue;
	const formattedValue = props.formattedValue;

	let menuItems = [
		<Dropdown.Header key="filterGroupData">Filter / Group Data</Dropdown.Header>
	];

	const page: string = categoricalCellDto.page;
	const pageState: PageState = StateHelper.getPageState();

	const menuStyle:CSSProperties = {
		backgroundColor: "white",
		zIndex: 100,
		display:"flex",
		flexDirection: "column",
		textAlign: "left",
		fontSize: "11px",
		cursor: "pointer"
	}

	const menuItemStyle:CSSProperties = {
		cursor: "pointer",
		display: "flex",
		flexDirection: "column",
	}

	const filterIconStyle:CSSProperties = {
		color: "#ccc",
		paddingRight: "0.25em"
	}

	menuItems.push(<div
		key={formattedValue}
		style={{...menuItemStyle}}
	>
		<NavDropdown.Item
			to={PagesHelper.getPageUrl(page, addFilterToPageState({...pageState}, props.categoricalCellDto, cellValue))}
			target="_blank"
			rel="noopener noreferrer" 
			as={Link}
			style={{ padding: "0.25rem 1.5rem" }}
			onClick={(e) => {
				// modify current tab only on left-click
				if (!e.metaKey && !e.ctrlKey) {
					e.preventDefault();
					props.hideMenu();
					addFilterToPageState(pageState, props.categoricalCellDto, cellValue);
					const searchFunction = StateHelper.getSearchFuntion(page);
					searchFunction();
				}
			}}
		>
			<FontAwesomeIcon icon={faFilter} style={filterIconStyle} fixedWidth></FontAwesomeIcon>
			Filter by this value ({formattedValue})
		</NavDropdown.Item>
	</div>);


	let selectedGroupBys: Record<string,boolean> = {};
	selectedGroupBys[column.id] = true;
	if (pageState.groupBy) {
		pageState.groupBy.split(",").forEach( gb => selectedGroupBys[gb] = true );
	}

	let allowedGroupByFields : string[] = null;
	if( props.currentUser !== undefined && props.currentUser !== null){
		allowedGroupByFields = props.currentUser.groupByFields ? props.currentUser.groupByFields : [];
	}
	else{
		allowedGroupByFields = [];
	}
	
	//Filter groupBy Items already in use.
	const groupByState = FiltersInitialStateHelper.getGroupByState(page, allowedGroupByFields);
	getGroupByArray(page, allowedGroupByFields, groupByState).forEach( groupBy => {
		if (selectedGroupBys[groupBy.id]) {
			return;
		}
		if (dateRangeColumnIds.includes(column.id) && dateRangeColumnIds.includes(groupBy.id as ColumnIds)) {
			return;
		}

		// skip offering group-by week if the current date range isn't week bounded
		// or if the current column is a date colulmn, which will change the dates to not be week bounded
		if ( groupBy.id === ColumnIds.week ) {
			const weekBounded = 
				pageState.dateStart.isSame(pageState.dateStart.startOf("isoWeek"), "day")
				&& pageState.dateEnd.isSame(pageState.dateEnd.endOf("isoWeek"), "day");

				if ( !weekBounded || isDateGroupBy(column.id) ) {
				return;
			}
		}

		// same for month
		if ( groupBy.id === ColumnIds.month ) {
			const monthBounded =
				pageState.dateStart.isSame(pageState.dateStart.startOf("month").startOf("day"), "day")
				&& pageState.dateEnd.isSame(pageState.dateEnd.endOf("month").startOf("day"), "day");

			if ( !monthBounded || isDateGroupBy(column.id) ) {
				return;
			}
		}

		// and for date, only show date if the date range is <93 days, or this is a date column (which will reduce the range)
		if ( groupBy.id === ColumnIds.date ) {
			const smallEnough = pageState.dateEnd.diff(pageState.dateStart, "days") < 93;
			if ( !smallEnough && !isDateGroupBy(column.id) ) {
				return;
			}
		}

		menuItems.push(<div
			key={formattedValue + ":" + groupBy.id}
			style={{...menuItemStyle}}
		>
			<NavDropdown.Item 
				to={PagesHelper.getPageUrl(page, addFilterAndGroupByToPageState({...pageState}, props.categoricalCellDto, groupBy.id, cellValue))}
				target="_blank"
				rel="noopener noreferrer" 
				as={Link}
				style={{ padding: "0.25rem 1.5rem", marginLeft: "3em" }}
				onClick={(e) => {
					// modify current tab only on left-click
					if (!e.metaKey && !e.ctrlKey) {
						e.preventDefault();
						props.hideMenu();
						addFilterAndGroupByToPageState(pageState, props.categoricalCellDto, groupBy.id, cellValue);
						const searchFunction = StateHelper.getSearchFuntion(page);
						searchFunction();
					}
				}}
			>
				<FontAwesomeIcon icon={faFilter} style={filterIconStyle}  fixedWidth></FontAwesomeIcon>
				&hellip; and group by: ({groupBy.name})
			</NavDropdown.Item>
		</div>);
	});

	return (
		<div style={menuStyle}>
			{menuItems}
		</div>
	)
}